import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router';
import { registerSW } from 'virtual:pwa-register';
import ScrollToTop from './components/ScrollToTop';
import App from './App';
import './index.css';
import { prefetchCommonRoutes } from './lib/prefetch';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <Router>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Router>
);

registerSW({ immediate: true });
prefetchCommonRoutes();
